import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

export type NavMenuItem = {
  title: string;
  path: string;
  counter$?: Observable<number>;
  visibility?: boolean;
};

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() links: NavMenuItem[];

  constructor() {}

  ngOnInit(): void {}
}
